(function() {
  'use strict';
  angular.module('dnPrinter',[])
  .directive('dnPrinter', ['$window', function($window){
    // Runs during compile
    return {
      controller: function($window) {
        let doc = $window.document;
        this.print = () => {
          let clone = this.target.clone();
          let container = doc.getElementById('dnPrintable');
          if (!container) {
            container = doc.createElement('div');
            container.id = 'dnPrintable';
            doc.body.appendChild(container);
          }
          while (container.firstChild) {
            container.removeChild(container.firstChild);
          }
          container.appendChild(clone[0]);
          $window.print();
        };
        this.$destroy = () => {
          var container = doc.getElementById('dnPrintable');
          if (container) {
            container.parentNode.removeChild(container);
          }
        };
      },
      link: function($scope, e, attrs, controller) {
        let name = attrs.dnPrinter || 'dnPrinter';
        controller.target = e;
        $scope[name] = controller;
        let bindKey = attrs.bindToKeyboard !== 'false';
        let keys = ['ctrl+p','command+p'];
        bindKey && $window.Mousetrap.bind(keys, (e) => {
          controller.print();
          e.preventDefault();
        });
        $scope.$on('$destroy', function() {
          $scope[name] = undefined;
          controller.$destroy();
          bindKey && $window.Mousetrap.unbind(keys);
        });
      }
    };
  }]);
})();
